import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Kansas = () => {
  return (
    <StatePropertyTaxPage
      stateName="Kansas"
      processDescription="Informal appeals must be filed within 30 days of the mailing date of the notice of value, either online, by mail, or in person. Appeals are heard by the county appraiser's office. Further appeals may go to the Kansas Board of Tax Appeals."
      noticeOfValueMailed="March 1"
      noticeOfValueMailedDateExplanation="By law, real property notices of value must be mailed by March 1 each year unless an extension is granted."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Kansas statute requires valuation as of January 1 each year for the current tax year. This assessment date captures the property's condition and market value at the beginning of each calendar year."
      deadlineExplanation="Property owners have 30 days after the notice mailing date to file informal appeals. March 30th is typical, but could be sooner depending on the actual mailing date. Appeals must be filed within this window to preserve appeal rights."
    />
  );
};

export default Kansas;